import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  IconAppointment,
  IconBookings,
  IconEmpty,
  IconFileCheck,
  IconMap,
  IconPayment,
  IconUserAlt,
} from "../icons";
import { LogoPortPro, LogoPortProSmall } from "../customIcons";

class TrackOsSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuHovered: false,
      isMenuClicked: null,
      isMenuOpen: false,
    };
    this.handleMenuHover = this.handleMenuHover.bind(this);
  }
  handleMenuHover() {
    this.setState((prevState) => ({
      isMenuHovered: !prevState.isMenuHovered,
      isMenuClicked:
        prevState.isMenuHovered && prevState.isMenuClicked
          ? null
          : prevState.isMenuClicked,
    }));
  }
  handleMenuClick = (i) => {
    this.setState({
      isMenuClicked: this.state.isMenuClicked === i ? null : i,
    });
  };

  handleSmartRoute(getRoute) {
    localStorage.setItem("role", getRoute);
    window.location.replace("/");
  }
  render() {
    return (
      <aside
        className={`left-sidebar ${this.state.isMenuHovered ? "ishovered" : ""
          }`}
        onMouseEnter={this.handleMenuHover}
        onMouseLeave={this.handleMenuHover}
      >
        {/* Sidebar scroll*/}
        {/* Sidebar navigation*/}
        <nav className="sidebar-nav">
          <div className="d-flex align-items-center justify-content-between">
            <a className="navbar-brand" href="javascript:void(0)">
              {/* Logo Expand */}
              <LogoPortPro className="navbar-brand__logo-big" />
              {/* Logo Small */}
              <LogoPortProSmall className="navbar-brand__logo-small" />
            </a>
          </div>
          <div id="sidebarnav" className="sidebar-content">
            <Link
              className="sidebar-item"
              to="/trackos/tracking"
              activeClassName={"active"}
            >
              <div className="sidebar-link">
                <IconMap />
                <span className="hide-menu">Tracking</span>
              </div>
            </Link>
            <Link
              className="sidebar-item"
              to="/trackos/import-availability"
              activeClassName={"active"}
            >
              <div className="sidebar-link">
                <IconFileCheck />
                <span className="hide-menu">Import Availability</span>
              </div>
            </Link>
            <Link
              className="sidebar-item"
              to="/trackos/bookings"
              activeClassName={"active"}
            >
              <div className="sidebar-link">
                <IconBookings />
                <span className="hide-menu">Bookings</span>
              </div>
            </Link>
            <Link
              className="sidebar-item"
              to="/trackos/empty-return"
              activeClassName={"active"}
            >
              <div className="sidebar-link">
                <IconEmpty />
                <span className="hide-menu">Empty Return</span>
              </div>
            </Link>
            <Link
              className="sidebar-item"
              to="/trackos/profile"
              activeClassName={"active"}
            >
              <div className="sidebar-link">
                <IconAppointment />
                <span className="hide-menu">Appointment</span>
              </div>
            </Link>
            <Link
              className="sidebar-item"
              to="/trackos/payment-options"
              activeClassName={"active"}
            >
              <div className="sidebar-link">
                <IconPayment />
                <span className="hide-menu">Payment Options</span>
              </div>
            </Link>
            <Link
              className="sidebar-item"
              to="/trackos/profile"
              activeClassName={"active"}
            >
              <div className="sidebar-link">
                <IconUserAlt />
                <span className="hide-menu">Profile</span>
              </div>
            </Link>
            <div
              className={`sidebar-item ${this.state.selected == "goto" ? "active" : ""
                } ${this.state.isMenuClicked === "goto" ? "isclicked" : ""}`}
              onClick={() => this.handleMenuClick("goto")}
            >
              <div className="sidebar-link has-arrow">
                <i className="uil uil-files-landscapes-alt"></i>
                <span className="hide-menu">Go To</span>
              </div>
              <div
                aria-expanded="false"
                className={`first-level ${this.state.isMenuOpen ? "collapse in" : "collapse"
                  } `}
              >
                <Link
                  className="first-level__link"
                  onClick={() => this.handleSmartRoute("drayos")}
                  activeClassName={"active"}
                  to="/"
                >
                  DrayOs
                </Link>
                <Link
                  className="first-level__link"
                  onClick={() => this.handleSmartRoute("shipos")}
                  activeClassName={"active"}
                  to="/"
                >
                  ShipOs
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </aside>
    );
  }
}

export default TrackOsSidebar;
